export default __webpack_public_path__ + "static/media/datafuse-logo.1c691616.svg";